import React from 'react';
import { ContentLoading, ErrorPage } from 'axway-react-ui';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from '../actions';
import APIsView from '../view/APIsView';
import APIImport from './APIImport';

export class APIsContainer extends React.Component {
	constructor(props) {
		super(props);
		this.onImportApi = this.onImportApi.bind(this);
	}

	onImportApi(type) {
		this.props.actions.importApi(type);
	}

	render() {
		const { apis, apiSpecTypes, error, importDetail, loading } = this.props;
		if (error) {
			return (
				<ErrorPage errorDetail={this.props.errorDetail} />
			);
		} else if (importDetail && apiSpecTypes) {
			return (
				<APIImport />
			);
		} else if (apis && apiSpecTypes && !loading) {
			return (
				<APIsView
					items={apis}
					apiSpecTypes={apiSpecTypes}
					onImportApi={this.onImportApi}
				/>
			);
		}
		return <ContentLoading />;
	}
}

function mapStateToProps(state) {
	return {
		loading: state.apidocs.loading,
		apis: state.apidocs.apis,
		apiSpecTypes: state.apidocs.apiSpecTypes.types,
		importDetail: state.apidocs.importDetail,
		error: state.apidocs.error || state.apidocs.apiSpecTypes.error,
		errorDetail: state.apidocs.errorDetail || state.apidocs.apiSpecTypes.errorDetail
	};
}

function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(actions, dispatch)
	};
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(APIsContainer);
